<template>
    <div>
      <modals-container name="modal1" />
      <v-dialog name="dialog" />
      <div class="admin_title">证书管理</div>
      <div class="gj_top_class">
        <!--select name="">
          <option>证书主题</option>
        </select>
        <select name="">
          <option>证书类型</option>
        </select>
        <select name="">
          <option>启用状态</option>
        </select-->
        <a @click="to('cert', 'void')">新增证书模板</a>
      </div>
      <div class="certificate_list" style="min-height: 800px;">
        <!--暂无证书提示-->
        <h5 class="none_ts" v-if="lists.length == '0'">
          <img src="@/assets/images/none_data.jpg" alt="">
        </h5>
        <!--暂无证书提示-->
        <dl v-for="item in lists" :key="item.id">
          <dt>
            <a :class="[item.isPublished == '1' ? 'on': '']">{{item.isPublished=='0'?'停用':'启用'}}</a>
            <img src="@/assets/images/zs_pic@2x.png" v-if="!item.url || item.url == ''" />
            <img :src="item.url" v-if="item.url && item.url !== ''">
            <p class="cl_icon">
              <span v-if="item.isPublished=='1'" @click="disableT(item.id)">停用</span><span v-if="item.isPublished=='0'"  @click="enableT(item.id)">启用</span>|<span @click="view(item.id)">预览</span>|<span @click="to('cert', item.id)">编辑</span>|<span @click="del(item.id)">删除</span>
            </p>
          </dt>
          <dd>
            {{item.name}}
          </dd>
        </dl>
      </div>
      <div class="zy_list_bottom mtf30">
        <dl>
          <dt v-if="cnt && cnt > 0"><!--<input id="sel_1" onchange="selectAll()" type="checkbox" value="1" style="opacity: 1;"/> 全选 <input name="" type="button" value="批量上架" class="btn_zy_bottom" /> <input name="" type="button" value="批量下架"  class="btn_zy_bottom"/> <input name="" type="button" value="删除所选"  class="btn_zy_bottom" />-->共{{cnt}}个证书</dt>
          <dd v-if="cnt>0">
            <paginate :click-handler="clickCallback" :page-count=pages
                      :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                      :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                      :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                      :first-last-button=$global.paginationOptions.first_last_button
                      :active-class=$global.paginationOptions.active_class
                      :disabled-class=$global.paginationOptions.disabled_class
                      :first-button-text=$global.paginationOptions.first_button_text
                      :last-button-text=$global.paginationOptions.last_button_text
                      :prev-text=$global.paginationOptions.prev_text
                      :next-text=$global.paginationOptions.next_text>
            </paginate>
          </dd>
        </dl>
      </div>
      <div class="clear"></div>
    </div>
</template>

<script>
  import config from '@/config'
  import api from '@/api'
  import { mapGetters } from 'vuex'
  import Paginate from 'vuejs-paginate'
  import CertView from '@/page/byl/org/cert/view.vue'
  import utils from '@/utils'
  export default {
    components: { Paginate },
    data () {
      return {
        lists: [],
        filters: {
          pageNo: 1,
          pageSize: 9,
          delFlag: '0'
        },
        labelsMap: {
          'user_name': '刘海',
          'dep_name': 'xxx有限公司',
          'position': '钢铁侠',
          'cert_code': '20080001',
          'cert_date': '2018-09-18',
          'user_idCardNo': '310xxxxxxxxxxx0987',
          'userplan_achievement': '35',
          'qrCodeUrl_1': '二维码串'
        },
        pages: 0,
        cnt: 0
      }
    },
    mounted () {
      this.search(this.filters) //  默认无搜索条件获取列表
    },
    methods: {
      clickCallback (pageNum) {
        this.filters.pageNo = pageNum
        this.search(this.filters)
      },
      to (path, id) {
        this.$router.push({
          path: path + '/' + id
        })
      },
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: o.title,
          text: o.text,
          buttons: [
            {
              title: '确认',
              default: true,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      del (id) {
        if (id) {
          var that = this
          this.confirmBox({
            title: '删除',
            text: '确认删除吗?',
            yes: function () {
              api.post(config.certApiPath, '/cert-templates/delete/' + id, null, r => {
                that.$toasted.show('删除成功')
                that.search(that.filters)
                that.$modal.hide('dialog')
              })
            }
          })
        }
      },
      enableT (id) {
        if (id) {
          var that = this
          this.confirmBox({
            title: '启用',
            text: '确认启用吗?',
            yes: function () {
              api.post(config.certApiPath, '/cert-templates/enable/' + id, null, r => {
                that.$toasted.show('模板启用成功')
                that.search(that.filters)
                that.$modal.hide('dialog')
              })
            }
          })
        }
      },
      disableT (id) {
        if (id) {
          var that = this
          this.confirmBox({
            title: '停用',
            text: '确认停用吗?',
            yes: function () {
              api.post(config.certApiPath, '/cert-templates/disable/' + id, null, r => {
                that.$toasted.show('模板停用成功')
                that.search(that.filters)
                that.$modal.hide('dialog')
              })
            }
          })
        }
      },
      view (id) {
        this.$modal.show(CertView, {
          id: id,
          p: this.labelsMap
        })
      },
      search (filters) {
        var that = this
        api.post(config.certApiPath, '/cert-templates/search', filters, r => {
          that.lists = r.data
          that.cnt = r.cntData
          that.pages = r.cntPage
        })
      }
    },
    computed: {
      ...mapGetters('auth', ['getCurrentOrg'])
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/byl/org/cert/list.vue